export default __webpack_public_path__ + "static/media/p5.b4541780.jpeg";